import { Link as RouterLink, useParams } from 'react-router-dom'
import BaseTable, { BaseSearch }         from '../ui/components/base-table'
import {
  Box, Button, Container,IconButton, Link, Stack, Typography
}                                        from '@mui/material'
import Page                              from '../ui/components/Page'
import Iconify                           from '../ui/components/Iconify'
import { useTranslation }                from 'react-i18next'
import React, { useEffect, useState }    from 'react'
import { useApi }                        from '../utils/api'
import { BaseBreadcrumbs }               from '../ui/components/BaseBreadcrumbs'
import { downloadBlob }                  from '../utils/utils'

export default function ServiceDigitalAccessPage() {

  const api = useApi()
  const { t } = useTranslation()
  const { serviceId } = useParams()
  const [service, setService] = useState()
  const [query, setQuery] = useState('')

  useEffect(() => {
    api.service.detail(serviceId).then(srv => setService(srv)).catch(err => console.error(err))
  }, [serviceId])

  const columns = [
    { field: 'id', headerName: t('ID'), width: 100, sortable: false, filterable: false },
    { field: 'inputCode', headerName: t('Web code'), flex: 1, sortable: false, filterable: false },
    { field: 'outputCode', headerName: t('Server code'), flex: 1, sortable: false, filterable: false },
    { field: 'transactionId', headerName: t('Transaction'), flex: 1, sortable: false, filterable: false, renderCell: (cell) => {
      if (!cell.row.transactionId) {
        return ''
      }
      return (<Link component={RouterLink} variant="body2" to={`/transactions/${cell.row.transactionId}`}>{cell.row.transactionId}</Link>)
    }},
  ];

  const exportCodes = async (e) => {
    e.preventDefault()
    const csvBlob = await api.digitalAccess.exportCodes(serviceId)
    downloadBlob(csvBlob, 'codes.csv')
  }

  return (<Page title={t('Digital access codes')}>
    <Container>
      <BaseBreadcrumbs key={'breadcrumb-services'}
                       title={t('Digital access codes')}
                       items={[]} />
      <Stack direction="row" alignItems="center" spacing={2} mb={2}>
        <Typography variant="h4" gutterBottom>{service?.title ?? ''}</Typography>
        <BaseSearch query={query} onQueryChanged={(query) => setQuery(query)} />
        <Box flexGrow={'1'} />
        <Button component={RouterLink} to={`/services/${serviceId}/digital-access/generate`} startIcon={<Iconify icon="material-symbols:add" />}>
          {t('Generate codes')}
        </Button>
        <IconButton onClick={exportCodes} color="primary">
          <Iconify icon="material-symbols:download" />
        </IconButton>
      </Stack>
      <BaseTable
        columns={columns}
        query={query}
        loadCallback={async (query, page, pageSize) => {
          try {
            return await api.digitalAccess.list(serviceId, query, page, pageSize)
          } catch (e) {
            console.log('Failed to load digital accesses', e)
            return {
              data: [],
              totalCount: 0,
            }
          }
        }}
      />
    </Container>
  </Page>)

}